import { MDBCol, MDBRow, MDBSwitch } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useStore } from "@/store/index";
import { shallow } from "zustand/shallow";
import styles from "@/styles/booking/privacySection.module.scss";

import Btn from "@/components/common/Btn";
import { TPrivacyData } from "@/models/userPage";
import useIsSubscribedNewsLetter from "@/utils/queries/hooks/useIsSubscribedNewsLetter";
import { useUpdatePrivacySection } from "@/utils/queries/hooks/useUpdatePrivacySection";

const PrivacySection = () => {
    const { email, ...privacyData } = useStore(
        state => ({
            marketingPromotions: state.userState.userDetail.marketingPromotions,
            policyPrivacy: state.userState.userDetail.policyPrivacy,
            email: state.userState.userDetail.email,
        }),
        shallow
    );

    const subscribed = useIsSubscribedNewsLetter(email);

    const [newsletter, setNewsletter] = useState(false);

    const dispatch = useStore(state => state.dispatchCommon);
    const dispatchUser = useStore(state => state.dispatchUser);
    const { mutate, isLoading } = useUpdatePrivacySection();

    const onChange = (key: keyof TPrivacyData) => {
        dispatchUser({
            type: "UPDATE_USER_DETAIL",
            // eslint-disable-next-line security/detect-object-injection
            payload: { [key]: !privacyData[key] },
        });
    };

    useEffect(() => {
        dispatch({ type: "SET_LOADER_PAGE", payload: isLoading });
    }, [dispatch, isLoading]);

    useEffect(() => {
        setNewsletter(!!subscribed && subscribed.subscription);
    }, [subscribed]);

    return (
        <MDBRow>
            <MDBRow>
                <MDBCol size={9}>
                    <MDBRow>
                        <p className={styles.title}>Policy Privacy</p>
                        <p className={styles.subtitle}>
                            Recevice notifications via mobile phone
                        </p>
                    </MDBRow>
                </MDBCol>
                <MDBCol size={3} className="d-flex justify-content-end">
                    <MDBSwitch
                        id="policyPrivacy"
                        checked={privacyData.policyPrivacy}
                        onChange={() => onChange("policyPrivacy")}
                        className={
                            privacyData.policyPrivacy
                                ? styles.customSwitch
                                : styles.customSwitchDisabled
                        }
                    />
                </MDBCol>
            </MDBRow>
            <MDBRow>
                <MDBCol size={9}>
                    <MDBRow>
                        <p className={styles.title}>Marketing Promotions</p>
                        <p className={styles.subtitle}>
                            Recevice notifications by your browser
                        </p>
                    </MDBRow>
                </MDBCol>
                <MDBCol size={3} className="d-flex justify-content-end">
                    <MDBSwitch
                        id="marketingPromotions"
                        checked={privacyData.marketingPromotions}
                        onChange={() => onChange("marketingPromotions")}
                        className={
                            privacyData.marketingPromotions
                                ? styles.customSwitch
                                : styles.customSwitchDisabled
                        }
                    />
                </MDBCol>
            </MDBRow>
            <MDBRow>
                <MDBCol size={9}>
                    <MDBRow>
                        <p className={styles.title}>Newsletter</p>
                        <p className={styles.subtitle}>
                            Recevice notifications by your email
                        </p>
                    </MDBRow>
                </MDBCol>
                <MDBCol size={3} className="d-flex justify-content-end">
                    <MDBSwitch
                        id="newsLetter"
                        checked={newsletter}
                        onChange={() => setNewsletter(!newsletter)}
                        className={
                            newsletter
                                ? styles.customSwitch
                                : styles.customSwitchDisabled
                        }
                    />
                </MDBCol>
            </MDBRow>
            <MDBRow>
                <MDBCol size={12} xl={3} className="my-3">
                    <Btn
                        onClick={() =>
                            mutate({
                                dataPrivacy: privacyData,
                                dataNewsletter: {
                                    email,
                                    subscribe: newsletter,
                                    subscribed:
                                        !!subscribed && subscribed.subscription,
                                },
                            })
                        }
                    >
                        Update Privacy
                    </Btn>
                </MDBCol>
            </MDBRow>
        </MDBRow>
    );
};

export default PrivacySection;
